import { render } from "./NewItem.vue?vue&type=template&id=1ce6c7b1&scoped=true"
import script from "./NewItem.vue?vue&type=script&lang=js"
export * from "./NewItem.vue?vue&type=script&lang=js"

import "./NewItem.vue?vue&type=style&index=0&id=1ce6c7b1&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce6c7b1"]])

export default __exports__